import * as React from "react";

import './breAcknowledgement.scss';

import {cs}             from "@Common/react/chain-services";
import {Checkbox}       from "@Common/ui-components/heavy/common/design2/checkbox/checkbox";


export const BreAcknowledgement = ({agreed, enableLicenseNumber, loading})=> cs(
    ({}) => (
        <div className="bre-acknowledgement-hj7">
            <div className="checkbox-container">
                <span className="agree"
                    onClick={() => agreed.onChange(!agreed.value)}>
                    {Checkbox({checked: agreed.value, xdQaName: "Terms and Acknowledgement"})}
                </span>
            </div>
            <div className="acknowledgement-text-container">
                {}
                    {enableLicenseNumber === 1 &&
                        <label xd-qa-type="label" xd-qa-name="Acknowledgement">
                            I understand that I have chosen not to include my license number as required by the state of California.
                            <br/>
                            <span>If you wish to change this, please edit your contact information to include your license number.</span>
                        </label>
                    }
                    {enableLicenseNumber === 2 &&
                        <label xd-qa-type="label" xd-qa-name="Acknowledgement">
                            I understand that California agents must include their California license number on all advertising materials.
                            <br/>
                            I agree to abide by this law by including my California license number on any advertisement I use.
                        </label>
                    }
            </div>
        </div>
    )
);